export const trackConversion = () => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-17663501404/jbjgCP2Mw68bENzIzuZB",
      value: 1.0,
      currency: "TRY",
    });
  }
};
